// extracted by mini-css-extract-plugin
module.exports = {"authNavContainer":"AuthNavigation_authNavContainer__2pcf8","registerLink":"AuthNavigation_registerLink__jIqZ3","loginLink":"AuthNavigation_loginLink__2_UGw"};